import dayjs from 'dayjs'
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat'
import timezonePlugin from 'dayjs/plugin/timezone'
import utcPlugin from 'dayjs/plugin/utc'
import relativeTimePlugin from 'dayjs/plugin/relativeTime'

import { DayJSLocale } from './types'
import { LOCALE_BY_LANGUAGE } from './constants'

import { Language } from 'common/types'

import 'dayjs/locale/ar'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/pt-br'

dayjs.extend(localizedFormatPlugin)
dayjs.extend(timezonePlugin)
dayjs.extend(utcPlugin)
dayjs.extend(relativeTimePlugin)

export default class DateHelper {
  static setLocale = (language: Language) => {
    const locale = LOCALE_BY_LANGUAGE[language] || DayJSLocale.EN

    dayjs.locale(locale)
  }

  /**
   * Function that receives the datetime and timezone and
   * returns it in the format: "Thursday, August 29, 2019 3:21 PM"
   */
  static convertISODateToLocaleFormatted = (
    date: dayjs.ConfigType,
    timezone: string,
    type = 'LLLL'): string => {
    try {
      return dayjs.utc(date).tz(timezone).format(type)
    } catch (error) {
      console.error(error)

      return ''
    }
  }

  static returnCurrentTimezone = () => {
    return dayjs.tz.guess()
  }

  static formatTimestampToTime = (timestamp: number): string => {
    const time = dayjs(timestamp).format('HH:mm')

    return time
  }

  static calculateRemainingTime = (
    date: Date,
    from: Date = new Date()
  ): number => {
    return date.getTime() - from.getTime()
  }

  static calculateTimeFields = (milliseconds: number): [number, number, number] => {
    const seconds = Math.floor(milliseconds / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)

    return [hours, (minutes % 60), (seconds % 60)]
  }

  static format = (
    date: dayjs.ConfigType,
    desiredFormat?: string,
    { timezone }: { timezone?: string } = {}) => {
    try {
      let dateObj = dayjs(date)

      if (timezone) {
        dateObj = dateObj.tz(timezone)
      }

      return dateObj.format(desiredFormat)
    } catch (error) {
      console.error(error)

      return ''
    }
  }

  static getRemainingTime(
    date: dayjs.ConfigType,
    unitOfTime: dayjs.OpUnitType = 'minute'
  ) {
    return dayjs(date).startOf(unitOfTime).fromNow()
  }
}
